import React from 'react';
import { motion } from 'framer-motion';

const Loading = () => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{ background: '#050816' }}>
      <motion.div
        className="text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {/* Spinning ring */}
        <div className="relative w-16 h-16 mx-auto mb-5">
          <motion.div
            className="absolute inset-0 rounded-full"
            style={{
              border: '2px solid rgba(0,212,255,0.12)',
              borderTopColor: '#00d4ff',
              boxShadow: '0 0 20px rgba(0,212,255,0.4)',
            }}
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          />
          <motion.div
            className="absolute inset-2 rounded-full"
            style={{
              border: '2px solid rgba(124,58,237,0.12)',
              borderBottomColor: '#7c3aed',
            }}
            animate={{ rotate: -360 }}
            transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
          />
        </div>
        <motion.p
          className="font-semibold tracking-widest text-xs uppercase"
          style={{ color: '#00d4ff', letterSpacing: '0.15em' }}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          Loading…
        </motion.p>
      </motion.div>
    </div>
  );
};

export default Loading;
